import React from 'react';

import Box from '@mui/material/Box';

import { useParentStyleCriteria } from '../../contexts/ParentStyleContext';

const Content = ({ children, contentPadding }) => {
  const { padding } = useParentStyleCriteria();

  return (
    <Box
      component="main"
      sx={{
        flex: 1,
        minWidth: 0,
        height: '100vh',
        overflowY: 'scroll',
        padding: contentPadding ?? padding,
      }}
    >
      {children}
    </Box>
  );
};

export default Content;
